import React, { ChangeEvent, useState } from 'react';

import { useArchiveList } from '../../../hooks/Request/useArchiveList';
import { useLoader } from "../../../hooks/useLoader";
import { useNavigate } from 'react-router-dom';

import ApiService from "../../../services/ApiServiceClass";

import RequestListTable from '../../Tables/RequestListTable';
import UpdateStatusModal from '../../Modals/UpdateStatusModal';

const ArchivedPurchasedRequestCard: React.FC = () => {

    const [openModal, setOpenModal] = useState(false);
    const [changeRequestID, setChangeRequestID]  = useState(0);
    const [newStatus, setNewStatus] = useState("New");
    const [remarks, setRemarks] = useState("");

    const requestList = useArchiveList();
    const loader = useLoader();

    const navigate = useNavigate();

    const handleRemarksInputChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        setRemarks(e.target.value);
    }

    const handleChangeStatus = () => {

        const formData = new FormData();
        formData.append('requestID', changeRequestID.toString());
        formData.append('newstatus', newStatus);
        formData.append('remarks', remarks);

        loader?.setIsLoading(true);
        try {
        ApiService.changeRequestStatus(formData)
            .then(() => {
                requestList?.fetchList();
                loader?.setIsLoading(false);
                setOpenModal(false);
            })
            .catch((error) => {
                console.log(error);
            });
        } catch(error) {
        loader?.setIsLoading(false);
        navigate("/login");
        }
    }


    const handleChangeToWaitlist = (id: number) => {
        setChangeRequestID(id);
        setNewStatus("Waitlisted");
        setRemarks("");
        setOpenModal(true);
    }

    const handleCustomChangeStatus = (id: number, status: string) => {
    setChangeRequestID(id);
    setNewStatus(status);
    setRemarks("");
    setOpenModal(true);
    }

    const handleChangeToApprove = (id: number) => {
        setChangeRequestID(id);
        setNewStatus("Approved");
        setOpenModal(true);
    }

    const handleChangeToDissapprove = (id: number) => {
        setChangeRequestID(id);
        setNewStatus("Declined");
        setRemarks("");
        setOpenModal(true);
    }

    return (
        <>
            <RequestListTable             
                        tableHeader="Purchased Requests"
                        statusType='Purchased'
                        items={requestList?.purchasedList} 
                        handleChangeStatus={handleCustomChangeStatus}
                        handleChangeToApprove={handleChangeToApprove} 
                        handleChangeToDissapprove={handleChangeToDissapprove} 
                        handleChangeToWaitlist={handleChangeToWaitlist} 
                    />
            <UpdateStatusModal 
                        openModal={openModal} 
                        setOpenModal={setOpenModal} 
                        requestID={changeRequestID} 
                        newStatus={newStatus} 
                        remarks={remarks}
                        handleInputChange={handleRemarksInputChange} 
                        handleChangeStatus={handleChangeStatus}
                    />
        </>
    );
};

export default ArchivedPurchasedRequestCard;